export const FIELDS = {
  coupon: 'coupon'
};
